<template>
  <div class="side-float-nav">
    <ul>
      <li v-for="sec in sections" :class="{ active: sec.active }">
        <a href="#" v-scroll-to="{ el: `#${sec.name}`, offset: -40, onDone: onDone(sec) }">
          <span class="text">{{ $t(`building_page.${sec.name}Anchor`) }}</span>
          <span class="point"></span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
  import inView from 'in-view';

  export default {
    props: ['sections'],
    methods: {
      onDone(sec) {
        return function callback() {
          inView.emit('enter', document.querySelectorAll(`#${sec.name}`)[0]);
        };
      },
    },
  };
</script>
<style scoped>
.side-float-nav {
  position: fixed;
  top: 40%;
  z-index: 100000;
}

ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0;
}

ul > li a {
  display: block;
  margin-bottom: 12px;
  text-decoration: none;
}

ul > li a .point {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background: #abd6d6;
  display: inline-block;
  margin: 2px 0px;
  box-shadow: 1px 1px 1px #6f6f6f;
}

ul > li a .text {
  display: none;
  color: #000;
  background: #fee735;
  margin-right: 4px;
  border-radius: 8px;
  box-shadow: 1px 1px 1px #6f6f6f;
  padding: 0 8px;
  position: absolute;
  right: 118%;
  min-width: max-content;
}

ul > li:hover a .point,
ul > li.active a .point {
  background: #fee735;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  margin: 0px;
}

ul > li:hover a .text {
  display: inline-block;
}
</style>
